import React from "react";
import { LegalPage } from "@/components/LegalPage";
import { useSeo } from "@/lib/seo";

export default function Terms() {
  useSeo({
    title: "Terms & Conditions | Meridian Dental Studio",
    description: "Terms and conditions governing the use of the Meridian Dental Studio website and services, including scheduling, pricing estimates, insurance and payment responsibilities.",
    path: "/terms",
  });

  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms & Conditions"
      updated="June 2026"
      intro="These Terms & Conditions govern your use of the Meridian Dental Studio website and the services we provide. By accessing this website or booking an appointment, you agree to the terms below."
      sections={[
        {
          h: "1. Acceptance of terms & website use",
          p: [
            "By using this website, you accept these Terms & Conditions in full. If you disagree with any part of these terms, please do not use the site. Content is provided for general informational purposes and does not constitute dental or medical advice.",
            "Information on this website — including treatment descriptions and timelines — is educational and should not replace a professional consultation and examination.",
          ],
        },
        {
          h: "2. Treatment pricing estimates & insurance",
          p: [
            "Any pricing referenced on this website or during consultations is an estimate. Final costs depend on your clinical needs, materials selected, and the treatment plan agreed upon after examination.",
            "Insurance coverage varies by plan. While we make reasonable efforts to verify benefits and file claims on your behalf, coverage determinations and reimbursement are made solely by your insurance carrier. You remain responsible for any balance not covered by insurance.",
          ],
        },
        {
          h: "3. Payment responsibilities",
          p: [
            "Payment is due at the time of service unless other arrangements have been made in writing. We accept major credit cards, and financing through approved third-party partners.",
          ],
        },
        {
          h: "4. Appointments, late arrivals & cancellations",
          p: [
            "Please arrive on time for your appointment. Late arrivals may need to be shortened or rescheduled to respect other patients' scheduled time.",
          ],
          list: [
            "We request at least 24 hours' notice to cancel or reschedule.",
            "Repeated missed appointments or no-shows may incur a fee and affect future scheduling.",
            "Emergency and same-day appointments are subject to availability.",
          ],
        },
        {
          h: "5. Health history & informed consent",
          p: [
            "You are responsible for disclosing accurate and complete health history, current medications, allergies and relevant medical conditions. Withholding information may affect the safety and outcome of your care.",
            "Before treatment, you will be asked to provide informed consent. We will explain the nature of proposed treatment, alternatives, risks and expected outcomes so you can make an informed decision.",
          ],
        },
        {
          h: "6. Membership plans, vouchers & financing partners",
          p: [
            "Dental membership plans, gift vouchers and promotional offers are subject to their own terms, are non-transferable unless stated, and may not be combined with insurance or other discounts.",
            "Financing offered through third-party partners (such as CareCredit) is governed by that partner's separate agreement, approval criteria and interest terms.",
          ],
        },
        {
          h: "7. Third-party links & booking tools",
          p: [
            "This website may link to third-party booking tools, payment processors or informational resources. We are not responsible for the content, availability or practices of third-party services.",
          ],
        },
        {
          h: "8. Limitation of liability & privacy",
          p: [
            "To the fullest extent permitted by law, Meridian Dental Studio is not liable for indirect or consequential damages arising from use of this website. Your use of personal information is also governed by our Privacy Policy.",
          ],
        },
      ]}
    />
  );
}
